export const ToolSurfaceEnum = Object.freeze({
	PUBLIC_DEMO: "publicDemo",
	PRACTITIONER_TEMPLATE: "practitionerTemplate",
	CLIENT_WORK: "clientWork",
	RESULT_REVIEW: "resultReview",
	EMBED: "embed",
})
